import * as React from "react";
import {NavigateFunction, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {navigateTo} from "../../../navigateTo";

export const RootPage: React.FunctionComponent = () => {

    const navigate: NavigateFunction = useNavigate();

    useEffect(() => {
        navigateTo("/home", navigate);
    }, []);

    return <div data-testid="root-page"/>;
};

export default RootPage;
